// extracted by mini-css-extract-plugin
export default {"confirm":"ConfirmButton_confirm__FaLLr"};